// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { ITheme, IThemeComponent, IAjax, IEventSource, INewTheme } from '../../../../CommonScripts/Abstractions';
import { Events } from '../Core/Cadcorp.Web.Core.Events';

/**
* Represents a theme for an overlay served from the GeognoSIS http interface
* @public
*/
export class Theme implements ITheme, IEventSource {

    /**
     * @inheritdoc 
     */
    index: number;
    /**
    * @inheritdoc
    */
    title: string;
    /**
    * @inheritdoc
    */
    type: string;
    /**
    * @inheritdoc
    */
    disabled: boolean;
    /**
    * @inheritdoc
    */
    userAdded?: boolean;
    /**
    * @inheritdoc
    */
    definition?: INewTheme;
    /**
    * @inheritdoc
    */
    components: IThemeComponent[];
    /**
     * @property {string|null} m_sessionId The current session id
     * @private
     */
    private m_sessionId: string;
    /**
     * @property {string|null} baseUrl The base url for Geognosis
     * @private
     */
    private m_baseUrl: string;
    /**
     * @property {IAjax} m_ajaxWrapper An IAjax implementation to perform asynchronous requests
     * @private
     */
    private m_ajaxWrapper: IAjax;
    /**
     * @property {string} m_layerId The unique id for the swd this layer is in
     * @private
     */
    private m_layerId: string;
    /**
     * @property {string} m_mapName The name of the map
     * @private
     */
    private m_mapName: string;
    /**
    * @property {number} m_overlayIndex The position in the list of overlays
    * @private
    */
    private m_overlayIndex: number;
    /**
    * @property {Cadcorp.Core.Events} m_events The position in the list of overlays
    * @private
    */
    private m_events: Events;
    /**
    * Initialises a new instance of Theme
    * @constructor
    * @export
    */
    constructor(baseUrl: string,
        sessionId: string,
        overlayIndex: number,
        ajaxWrapper: IAjax,
        layerId: string,
        mapName: string) {
        this.m_baseUrl = baseUrl;
        this.m_sessionId = sessionId;
        this.m_overlayIndex = overlayIndex;
        this.m_ajaxWrapper = ajaxWrapper;
        this.m_layerId = layerId;
        this.m_mapName = mapName;
        this.m_events = new Events({owner:this});
    }
    /**
     * @inheritdoc 
     */
    on(type: string, listener: (eventData: any) => boolean) {
        this.m_events.on(type, listener);
    }
    /**
    * @inheritdoc
    */
    un(type: string, listener: (eventData: any) =>  boolean) {
        this.m_events.un(type, listener);
    }
    setDisabled(disabled: boolean): Promise<any> {
        //`${this.baseUrl}GeognoSis/${this.mapName}/${this.layerId}/Sessions/${this.sessionId}/Overlay/${this.overlayIndex}/Vector`
        var retVal = null;
        if (this.disabled !== disabled) {
            var url =
                `${this.m_baseUrl}GeognoSis/${this.m_mapName}/${this.m_layerId}/Sessions/${this.m_sessionId}/Overlay/${
                    this.m_overlayIndex}/Theme/${this.index}/disable?disabled=${disabled ? 1 : 0}`;
            retVal = this.m_ajaxWrapper.patch(url, null, null)
                .then((response) => {
                    this.disabled = disabled;
                    if (this.definition)
                        this.definition.propertyMap[ '_bDisabled&' ] = disabled;
                    this.m_events.dispatchEvent('changed', { theme: this });
                    return this;
                });
        } else
            retVal = Promise.resolve(this);

        return retVal;
    }
    public themeLegendUrl(): string {
        //GeognoSis/{mapName}/{layerId:Guid}/Sessions/{sessionId}/Overlay/{overlayNo:int}/Vector
        return `${this.m_baseUrl}GeognoSis/${this.m_mapName}/${this.m_layerId}/Sessions/${this.m_sessionId}/Overlay/${this.m_overlayIndex}/Theme/${this.index}/Legend?${performance.now()}`;
    }
}

/**
 *Horizontal Text alignment enum.
 */
export enum HorizontalTextAlignment {
    Left = 0,
    Right = 2,
    Centre=6
}
/**
 * Vertical Text alignment enum.
 */ 
export enum VerticalTextAlignment {
    Top = 0,
    Bottom = 2,
    Middle = 72
}


